"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateCode = exports.getCountryFromCode = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var STATES = (0, _freeze.default)({
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Northern Territory': 'NT',
  Queensland: 'QLD',
  'South Australia': 'SA',
  Tasmania: 'TAS',
  Victoria: 'VIC',
  'Western Australia': 'WA'
});
var countryCodeMap = {
  AU: 'Australia',
  NZ: 'New Zealand',
  AUS: 'Australia',
  NZL: 'New Zealand'
};
var getCountryFromCode = code => countryCodeMap[code];
exports.getCountryFromCode = getCountryFromCode;
var getStateCode = state => STATES[state];
exports.getStateCode = getStateCode;